import React from 'react';
import NoteEvent from '../../../../../../common/components/activity-events/note/NoteEvent';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import { BasicNoteEventProps } from '../../../../../../core/types/coreTypes';
import {
  deleteStockPartRequestTimelineNoteThunk,
  editStockPartRequestTimelineNoteThunk,
} from '../../../../../../store/thunks/stock/stock-part-requests/stockPartRequestsThunks';
import { useNoteActivityLog } from '../../../../../../common/hooks/useNoteActivityLog';

const StockPartRequestNoteEvent: React.FC<BasicNoteEventProps> = ({ id, content = '', initiator }) => {
  const {
    dispatch,
    value,
    setValue,
    isEditModal,
    isConfirmationModal,
    setIsConfirmationModal,
    closeHandle,
    menuItems,
  } = useNoteActivityLog(content);

  const editHandle = () => {
    id && dispatch(editStockPartRequestTimelineNoteThunk({
      id,
      content: value.trim(),
      closeModal: closeHandle,
    }));
  };

  const deleteHandle = () => {
    id && dispatch(deleteStockPartRequestTimelineNoteThunk({
      id,
      closeModal: () => setIsConfirmationModal(false),
    }));
  };

  return (
    <NoteEvent
      content={content}
      menuItems={menuItems}
      value={value}
      setValue={setValue}
      isEditModal={isEditModal}
      closeEditModal={closeHandle}
      editHandle={editHandle}
      isConfirmationModal={isConfirmationModal}
      setIsConfirmationModal={setIsConfirmationModal}
      deleteHandle={deleteHandle}
      initiator={initiator}
      permission={PermissionEnum.StockPartRequestEditDeleteNotesOfOtherUsersInActivityLog}
    />
  );
};

export default StockPartRequestNoteEvent;
